import { HandymanJobPage } from '@/index/service-category/handyman/HandymanJobPage'
import { PageAnalytics } from '@/commons/PageAnalytics'
import { getJobPageStaticProps } from 'utils/handyman-job-page-props'

// Copy lives in data/handyman-job-pages.js under 'clogged-toilet-bowl'.
export const getStaticProps = () => getJobPageStaticProps('clogged-toilet-bowl')

export default function Page(props) {
  return (
    <>
      <HandymanJobPage {...props} />
      <PageAnalytics />
    </>
  )
}
